//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import PopupPicker from 'vux/src/components/popup-picker';
import XInput from 'vux/src/components/x-input';
import XButton from 'vux/src/components/x-button';
import Datetime from 'vux/src/components/datetime';
import Group from 'vux/src/components/group';
import XTextarea from 'vux/src/components/x-textarea';
import UBT from '@/utils/ubt';
import { findRentalEmployees, addRentalDepotRecord } from '@/api/rentBike';

const mobileTest = /^1[0-9]{10}$/;

const now = new Date();
const defaultStartTime = `${dayjs(now).format('YYYY-MM-DD HH')}`;
const defaultEndTime = `${dayjs(new Date(+now + (7 * 24 * 3600 * 1000))).format('YYYY-MM-DD HH')}`;

export default {
  components: {
    PopupPicker,
    XInput,
    XButton,
    Group,
    Datetime,
    XTextarea,
  },
  data() {
    return {
      defaultStartTime,
      defaultEndTime,
      form: {
        employee: [],
        rentalName: '',
        rentalStartTime: '',
        rentalMobile: '',
        rentalEndTime: '',
        remark: '',
      },
      employeelist: [],
      displayFormat(val) {
        if (!val) return val;
        return `${val}:00`;
      }
    };
  },
  computed: {
    // vux datetime default-selected-value 属性不支持动态
    // defaultStartTime() {
    //   if (!this.form.rentalEndTime) return defaultStartTime;
    //   const rentalEndTime = new Date(`${this.form.rentalEndTime}:00:00`.replace(/-/g, '/'));
    //   return `${dayjs(new Date(+rentalEndTime
    //    - (7 * 24 * 3600 * 1000))).format('YYYY-MM-DD HH')}`;
    // },
    // defaultEndTime() {
    //   if (!this.form.rentalStartTime) return defaultEndTime;
    //   const rentalStartTime = new Date(`${this.form.rentalStartTime}:00:00`.replace(/-/g, '/'));
    //   return `${dayjs(new Date(+rentalStartTime
    //    + (7 * 24 * 3600 * 1000))).format('YYYY-MM-DD HH')}`;
    // },
    canSubmit() {
      return this.form.employee.length > 0
      && this.form.rentalName
      && this.form.rentalMobile
      && mobileTest.test(this.form.rentalMobile)
      && this.form.rentalStartTime
      && this.form.rentalEndTime;
    }
  },
  async mounted() {
    UBT.pageView({
      pageId: 'H5_换电_添加租车记录页',
    });
    try {
      const { employees = '' } = await findRentalEmployees() || {};
      this.employeelist = employees.split(',').map(item => ({
        name: item,
        value: item,
      }));
    } catch (e) {
      this.$throw(e);
    }
  },
  methods: {
    async submit() {
      UBT.clickButton({
        pageId: 'H5_换电_添加租车记录页',
        buttonName: 'H5_换电_添加租车记录页_确认添加',
      });
      const { rentalStartTime, rentalEndTime } = this.form;
      if (+new Date(`${rentalStartTime}:00:00`.replace(/-/g, '/')) >= +new Date(`${rentalEndTime}:00:00`.replace(/-/g, '/'))) {
        this.$throw(new Error('租车结束时间应大于租车开始时间'));
        return;
      }
      try {
        await addRentalDepotRecord(this.transform(this.form));
        this.$vux.toast.show({
          type: 'text',
          width: 'auto',
          text: '添加完成',
        });
        this.$router.back();
      } catch (e) {
        this.$throw(e);
      }
    },
    transform(data) {
      const params = JSON.parse(JSON.stringify(data));
      [params.employee] = params.employee;
      params.rentalStartTime = `${params.rentalStartTime}:00`;
      params.rentalEndTime = `${params.rentalEndTime}:00`;
      return params;
    },
    transBack(response) {
      response.employee = response.employee ? [response.employee] : [];
      return response;
    }
  }
};
